var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Keyframe = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _Easing = require("../../Easing");
var _animation = require("../../animation");
var _commonTypes = require("../../commonTypes");
var _util = require("../../animation/util");
var _worklet_4493391434462_init_data = {
    code: "function anonymous(){const{keyframes,delayFunction,delay,withTiming,Easing,withSequence,_this,initialValues,callback}=this.__closure;const animations={};const addAnimation=function(key){const keyframePoints=keyframes[key];if(keyframePoints.length===0){return;}const animation=delayFunction(delay,keyframePoints.length===1?withTiming(keyframePoints[0].value,{duration:keyframePoints[0].duration,easing:keyframePoints[0].easing?keyframePoints[0].easing:Easing.linear}):withSequence.apply(_this,keyframePoints.map(function(keyframePoint){return withTiming(keyframePoint.value,{duration:keyframePoint.duration,easing:keyframePoint.easing?keyframePoint.easing:Easing.linear});})));if(key.includes('transform')){if(!('transform'in animations)){animations.transform=[];}animations.transform.push({[key.split(':')[1]]:animation});}else{animations[key]=animation;}};Object.keys(initialValues).forEach(function(key){if(key.includes('transform')){initialValues[key].forEach(function(transformProp,index){Object.keys(transformProp).forEach(function(transformPropKey){addAnimation(index.toString()+'_transform:'+transformPropKey);});});}else{addAnimation(key);}});return{animations:animations,initialValues:initialValues,callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/Keyframe.ts",
    sourceMap: '{"version":3,"names":["anonymous","keyframes","delayFunction","delay","withTiming","Easing","withSequence","_this","initialValues","callback","__closure","animations","addAnimation","key","keyframePoints","length","animation","value","duration","easing","linear","apply","map","keyframePoint","includes","transform","push","split","Object","keys","forEach","transformProp","index","transformPropKey","toString"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/Keyframe.ts"],"mappings":"AA4NW,SAAAA,SAAMA,CAAA,QAAAC,SAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,UAAA,CAAAC,MAAA,CAAAC,YAAA,CAAAC,KAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,KAAM,CAAAC,UAAwC,CAAG,CAAC,CAAC,CAMnD,KAAM,CAAAC,YAAY,CAAG,QAAAA,CAACC,GAAW,CAAK,CACpC,KAAM,CAAAC,cAAc,CAAGb,SAAS,CAACY,GAAG,CAAC,CAErC,GAAIC,cAAc,CAACC,MAAM,GAAK,CAAC,CAAE,CAC/B,OACF,CACA,KAAM,CAAAC,SAAS,CAAGd,aAAa,CAC7BC,KAAK,CACLW,cAAc,CAACC,MAAM,GAAK,CAAC,CACvBX,UAAU,CAACU,cAAc,CAAC,CAAC,CAAC,CAACG,KAAK,CAAE,CAClCC,QAAQ,CAAEJ,cAAc,CAAC,CAAC,CAAC,CAACI,QAAQ,CACpCC,MAAM,CAAEL,cAAc,CAAC,CAAC,CAAC,CAACK,MAAM,CAC5BL,cAAc,CAAC,CAAC,CAAC,CAACK,MAAM,CACxBd,MAAM,CAACe,MACb,CAAC,CAAC,CACFd,YAAY,CAACe,KAAK,CAChBd,KAAI,CACJO,cAAc,CAACQ,GAAG,CAAC,SAACC,aAA4B,QAC9C,CAAAnB,UAAU,CAACmB,aAAa,CAACN,KAAK,CAAE,CAC9BC,QAAQ,CAAEK,aAAa,CAACL,QAAQ,CAChCC,MAAM,CAAEI,aAAa,CAACJ,MAAM,CACxBI,aAAa,CAACJ,MAAM,CACpBd,MAAM,CAACe,MACb,CAAC,CACH,GACF,CACN,CAAC,CACD,GAAIP,GAAG,CAACW,QAAQ,CAAC,WAAW,CAAC,CAAE,CAC7B,GAAI,EAAE,WAAW,EAAI,CAAAb,UAAU,CAAC,CAAE,CAChCA,UAAU,CAACc,SAAS,CAAG,EAAE,CAC3B,CAEAd,UAAU,CAACc,SAAS,CAAEC,IAAI,CAAqB,CAC7C,CAACb,GAAG,CAACc,KAAK,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,EAAGX,SACvB,CAAC,CAAC,CACJ,CAAC,IAAM,CACLL,UAAU,CAACE,GAAG,CAAC,CAAGG,SAAS,CAC7B,CACF,CAAC,CACDY,MAAM,CAACC,IAAI,CAACrB,aAAa,CAAC,CAACsB,OAAO,CAAC,SAACjB,GAAW,CAAK,CAClD,GAAIA,GAAG,CAACW,QAAQ,CAAC,WAAW,CAAC,CAAE,CAC7BhB,aAAa,CAACK,GAAG,CAAC,CAACiB,OAAO,CACxB,SAACC,aAA8C,CAAEC,KAAa,CAAK,CACjEJ,MAAM,CAACC,IAAI,CAACE,aAAa,CAAC,CAACD,OAAO,CAAC,SAACG,gBAAwB,CAAK,CAC/DrB,YAAY,CACVoB,KAAK,CAACE,QAAQ,CAAC,CAAC,CAAG,aAAa,CAAGD,gBACrC,CAAC,CACH,CAAC,CAAC,CACJ,CACF,CAAC,CACH,CAAC,IAAM,CACLrB,YAAY,CAACC,GAAG,CAAC,CACnB,CACF,CAAC,CAAC,CACF,MAAO,CACLF,UAAU,CAAEA,UAAU,CACtBH,aAAa,CAAEA,aAAa,CAC5BC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var _worklet_13836389523485_init_data = {
    code: "function anonymous(delay,animation){const{withDelay,reduceMotion}=this.__closure;return withDelay(delay,animation,reduceMotion);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/Keyframe.ts",
    sourceMap: '{"version":3,"names":["anonymous","delay","animation","withDelay","reduceMotion","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/Keyframe.ts"],"mappings":"AA2MQ,QAAC,CAAAA,SAAOA,CAAAC,KAAA,CAAAC,SAAc,QAAAC,SAAA,CAAAC,YAAA,OAAAC,SAAA,CAEpB,MAAO,CAAAF,SAAS,CAACF,KAAK,CAAEC,SAAS,CAAEE,YAAY,CAAC,CAClD"}',
    version: "3.5.4"
};
var _worklet_5312609872546_init_data = {
    code: "function anonymous(_,animation){const{getReduceMotionFromConfig,reduceMotion}=this.__closure;animation.reduceMotion=getReduceMotionFromConfig(reduceMotion);return animation;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/Keyframe.ts",
    sourceMap: '{"version":3,"names":["anonymous","_","animation","getReduceMotionFromConfig","reduceMotion","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/Keyframe.ts"],"mappings":"AA+MQ,QAAC,CAAAA,SAAGA,CAAAC,CAAA,CAAAC,SAAc,QAAAC,yBAAA,CAAAC,YAAA,OAAAC,SAAA,CAEhBH,SAAS,CAACE,YAAY,CAAGD,yBAAyB,CAACC,YAAY,CAAC,CAChE,MAAO,CAAAF,SAAS,CAClB"}',
    version: "3.5.4"
};
var InnerKeyframe = function() {
    function InnerKeyframe(definitions) {
        var _this = this;
        (0, _classCallCheck2.default)(this, InnerKeyframe);
        this.durationV = void 0;
        this.delayV = void 0;
        this.reduceMotionV = _commonTypes.ReduceMotion.System;
        this.callbackV = void 0;
        this.definitions = void 0;
        this.build = function() {
            var delay = _this.delayV;
            var delayFunction = _this.getDelayFunction();
            var _this$parseDefinition = _this.parseDefinitions(), keyframes = _this$parseDefinition.keyframes, initialValues = _this$parseDefinition.initialValues;
            var callback = _this.callbackV;
            return function() {
                var _e = [
                    new global.Error(),
                    -10,
                    -27
                ];
                var anonymous = function anonymous() {
                    var animations = {};
                    var addAnimation = function addAnimation(key) {
                        var keyframePoints = keyframes[key];
                        if (keyframePoints.length === 0) {
                            return;
                        }
                        var animation = delayFunction(delay, keyframePoints.length === 1 ? (0, _animation.withTiming)(keyframePoints[0].value, {
                            duration: keyframePoints[0].duration,
                            easing: keyframePoints[0].easing ? keyframePoints[0].easing : _Easing.Easing.linear
                        }) : _animation.withSequence.apply(_this, keyframePoints.map(function(keyframePoint) {
                            return (0, _animation.withTiming)(keyframePoint.value, {
                                duration: keyframePoint.duration,
                                easing: keyframePoint.easing ? keyframePoint.easing : _Easing.Easing.linear
                            });
                        })));
                        if (key.includes("transform")) {
                            if (!("transform" in animations)) {
                                animations.transform = [];
                            }
                            animations.transform.push((0, _defineProperty2.default)({}, key.split(":")[1], animation));
                        } else {
                            animations[key] = animation;
                        }
                    };
                    Object.keys(initialValues).forEach(function(key) {
                        if (key.includes("transform")) {
                            initialValues[key].forEach(function(transformProp, index) {
                                Object.keys(transformProp).forEach(function(transformPropKey) {
                                    addAnimation(index.toString() + "_transform:" + transformPropKey);
                                });
                            });
                        } else {
                            addAnimation(key);
                        }
                    });
                    return {
                        animations: animations,
                        initialValues: initialValues,
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    keyframes: keyframes,
                    delayFunction: delayFunction,
                    delay: delay,
                    withTiming: _animation.withTiming,
                    Easing: _Easing.Easing,
                    withSequence: _animation.withSequence,
                    _this: _this,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_4493391434462_init_data;
                anonymous.__workletHash = 4493391434462;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        this.definitions = definitions;
    }
    (0, _createClass2.default)(InnerKeyframe, [
        {
            key: "parseDefinitions",
            value: function parseDefinitions() {
                var _this2 = this;
                var parsedKeyframes = {};
                if (this.definitions.from) {
                    if (this.definitions["0"]) {
                        throw new Error("[Reanimated] You cannot provide both keyframe 0 and 'from' as they both specified initial values.");
                    }
                    this.definitions["0"] = this.definitions.from;
                    delete this.definitions.from;
                }
                if (this.definitions.to) {
                    if (this.definitions["100"]) {
                        throw new Error("[Reanimated] You cannot provide both keyframe 100 and 'to' as they both specified values at the end of the animation.");
                    }
                    this.definitions["100"] = this.definitions.to;
                    delete this.definitions.to;
                }
                if (!this.definitions["0"]) {
                    throw new Error("[Reanimated] Please provide 0 or 'from' keyframe with initial state of your object.");
                }
                var initialValues = this.definitions["0"];
                Object.keys(initialValues).forEach(function(styleProp) {
                    if (styleProp === "transform") {
                        if (!Array.isArray(initialValues.transform)) {
                            return;
                        }
                        initialValues.transform.forEach(function(transformStyle, index) {
                            Object.keys(transformStyle).forEach(function(transformProp) {
                                parsedKeyframes[index.toString() + "_transform:" + transformProp] = [];
                            });
                        });
                    } else {
                        parsedKeyframes[styleProp] = [];
                    }
                });
                var duration = this.durationV ? this.durationV : 500;
                var animationKeyPoints = Array.from(Object.keys(this.definitions));
                var getAnimationDuration = function getAnimationDuration(key, currentKeyPoint) {
                    var maxDuration = currentKeyPoint / 100 * duration;
                    var currentDuration = parsedKeyframes[key].reduce(function(acc, value) {
                        return acc + value.duration;
                    }, 0);
                    return maxDuration - currentDuration;
                };
                var addKeyPoint = function addKeyPoint(_ref) {
                    var key = _ref.key, value = _ref.value, currentKeyPoint = _ref.currentKeyPoint, easing = _ref.easing;
                    if (!(key in parsedKeyframes)) {
                        throw new Error("[Reanimated] Keyframe can contain only that set of properties that were provide with initial values (keyframe 0 or 'from')");
                    }
                    parsedKeyframes[key].push({
                        duration: getAnimationDuration(key, currentKeyPoint),
                        value: value,
                        easing: easing
                    });
                };
                animationKeyPoints.filter(function(value) {
                    return parseInt(value) !== 0;
                }).sort(function(a, b) {
                    return parseInt(a) - parseInt(b);
                }).forEach(function(keyPoint) {
                    if (parseInt(keyPoint) < 0 || parseInt(keyPoint) > 100) {
                        throw new Error("[Reanimated] Keyframe should be in between range 0 - 100.");
                    }
                    var keyframe = _this2.definitions[keyPoint];
                    var easing = keyframe.easing;
                    delete keyframe.easing;
                    var addKeyPointWith = function addKeyPointWith(key, value) {
                        return addKeyPoint({
                            key: key,
                            value: value,
                            currentKeyPoint: parseInt(keyPoint),
                            easing: easing
                        });
                    };
                    Object.keys(keyframe).forEach(function(key) {
                        if (key === "transform") {
                            if (!Array.isArray(keyframe.transform)) {
                                return;
                            }
                            keyframe.transform.forEach(function(transformStyle, index) {
                                Object.keys(transformStyle).forEach(function(transformProp) {
                                    addKeyPointWith(index.toString() + "_transform:" + transformProp, transformStyle[transformProp]);
                                });
                            });
                        } else {
                            addKeyPointWith(key, keyframe[key]);
                        }
                    });
                });
                return {
                    initialValues: initialValues,
                    keyframes: parsedKeyframes
                };
            }
        },
        {
            key: "duration",
            value: function duration(durationMs) {
                this.durationV = durationMs;
                return this;
            }
        },
        {
            key: "delay",
            value: function delay(delayMs) {
                this.delayV = delayMs;
                return this;
            }
        },
        {
            key: "withCallback",
            value: function withCallback(callback) {
                this.callbackV = callback;
                return this;
            }
        },
        {
            key: "reduceMotion",
            value: function reduceMotion(reduceMotionV) {
                this.reduceMotionV = reduceMotionV;
                return this;
            }
        },
        {
            key: "getDelayFunction",
            value: function getDelayFunction() {
                var delay = this.delayV;
                var reduceMotion = this.reduceMotionV;
                return delay ? function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous(delay, animation) {
                        return (0, _animation.withDelay)(delay, animation, reduceMotion);
                    };
                    anonymous.__closure = {
                        withDelay: _animation.withDelay,
                        reduceMotion: reduceMotion
                    };
                    anonymous.__initData = _worklet_13836389523485_init_data;
                    anonymous.__workletHash = 13836389523485;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }() : function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous(_, animation) {
                        animation.reduceMotion = (0, _util.getReduceMotionFromConfig)(reduceMotion);
                        return animation;
                    };
                    anonymous.__closure = {
                        getReduceMotionFromConfig: _util.getReduceMotionFromConfig,
                        reduceMotion: reduceMotion
                    };
                    anonymous.__initData = _worklet_5312609872546_init_data;
                    anonymous.__workletHash = 5312609872546;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }();
            }
        }
    ]);
    return InnerKeyframe;
}();
var Keyframe = exports.Keyframe = InnerKeyframe;
